/**
 * Hook useToast
 * Gerencia notificações toast da aplicação
 */

import { useState, useCallback } from "react";
import { toUserErrorMessage } from "../lib/errorHandler";

let toastIdCounter = 0;

const useToast = () => {
  const [toasts, setToasts] = useState([]);

  /**
   * Adiciona uma nova notificação
   */
  const addToast = useCallback((message, type = "info", duration = 5000) => {
    const id = `toast-${++toastIdCounter}`;
    const newToast = {
      id,
      message,
      type,
      duration,
      timestamp: Date.now(),
    };

    setToasts(prev => [...prev, newToast]);
    return id;
  }, []);

  /**
   * Remove uma notificação
   */
  const removeToast = useCallback(id => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  }, []);

  /**
   * Limpa todas as notificações
   */
  const clearAll = useCallback(() => {
    setToasts([]);
  }, []);

  /**
   * Métodos de conveniência para tipos específicos
   */
  const success = useCallback(
    (message, duration) => addToast(message, "success", duration),
    [addToast]
  );

  const error = useCallback(
    (message, duration) => addToast(toUserErrorMessage(message), "error", duration),
    [addToast]
  );

  const warning = useCallback(
    (message, duration) => addToast(message, "warning", duration),
    [addToast]
  );

  const info = useCallback((message, duration) => addToast(message, "info", duration), [addToast]);

  return {
    toasts,
    addToast,
    removeToast,
    clearAll,
    success,
    error,
    warning,
    info,
  };
};

export default useToast;
